export default {"src":"/_next/static/media/MoneyCircle.cae8b239.svg","height":80,"width":80};